module.exports = __webpack_public_path__ + "images/of-the-nights-watch-11a9cfead3e86b8413cf622cf8b47474.png";